import { render, staticRenderFns } from "./SingleNotification.vue?vue&type=template&id=777f56db&"
import script from "./SingleNotification.vue?vue&type=script&lang=js&"
export * from "./SingleNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports